// extracted by mini-css-extract-plugin
export default {"container":"ReservationRegistrationManual_container__XzCkq"};